import {Injectable} from '@angular/core';
import {DialogService} from "../../../ng2-bootstrap-modal/dialog.service";
import {UnavailableDialogComponent} from "./plugins/plugin-download-dialog/unavailable-dialog.component";
import {TextUtils} from "../../shared/utils/text-utils";
import {Product} from "./product";
import {DbStoreState} from "../../store/reducers";
import {Store} from '@ngrx/store';
import {UserService} from "../../user/user.service";
import {getTenWebPluginsAndExtensions, getUserLoaded, getUserSubscription} from "../../store/selectors";
import {UserSubscription} from "../../user/user-subscription";
import {filter, first, switchMap} from 'rxjs/operators';
import {Config} from "../../config/config";

@Injectable()
export class ProductStatusActionService {

  private unavailableDialogOpened: boolean;

  constructor(
    private _dialogService: DialogService,
    private _userService: UserService,
    private _store: Store<DbStoreState>
  ) {}

  public openUnavailableWebsiteDialog(websiteId) {
    if (this.unavailableDialogOpened) {
      return;
    }

    this._store.select(getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(getUserSubscription)),
        first()
      )
      .subscribe((userSubscription: UserSubscription) => {
        if (userSubscription) {
          this._store.select(getTenWebPluginsAndExtensions(websiteId))
          .pipe(first())
            .subscribe((plugins: Product[]) => {
              if (plugins) {
                plugins = plugins.filter( (plugin: Product): boolean => !!plugin.hasPaidVersion );

                if (!userSubscription?.oneProductOrBundle || this.unavailableDialogOpened) {
                  return;
                }

                this.unavailableDialogOpened = true;
                this._dialogService
                  .addDialog(UnavailableDialogComponent, {
                    header: TextUtils.getText('text_unavailablePluginDownload.installFailedTitle'),
                    plugins: plugins.filter((product: Product) => product.slug !== Config.optimizerPluginSlug),
                    userSubscription: userSubscription.type,
                    fromLocal: ''
                  })
                  .subscribe((confirmed: boolean) => {
                    this.unavailableDialogOpened = false;
                  });
              }
            });
        }
      });
  }

}
